/**
 * Type-safe wrapper over {@link WsClient.request} using {@link WsOpContracts}
 * — infers the request/response shape from `op` instead of the caller
 * supplying `request<TResult>()`'s generic by hand. Purely additive:
 * `WsClient.request` itself is unchanged, this just narrows it for the ops
 * registered above.
 */
export async function requestTyped(client, op, payload, opts) {
    return client.request(op, payload, opts);
}
